/*global VeloxWebView, VeloxDatabaseClient, VeloxServiceClient*/

var uuid = require("uuid") ;
var sync = require("./sync") ;

var checkConnectedId = null;
/**
 * Called on login or refresh
 */
module.exports = function(api, callback){
    checkConnectedId = setInterval(function(){
        api.refreshUser(function(err){
            if(err){
                if(checkConnectedId){
                    clearInterval(checkConnectedId) ;
                }
            }
        });
    }, 1000*60*60) ;
    if(api.currentUser.realms.length === 1){
        //don't autosync before check reseller options
        VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_MANUAL) ;
        api.api.reseller.searchFirst({r_code : api.currentUser.realms[0].realm.code}, function(err, resellerLocal){
            if(err){
                resellerLocal = {r_lang: "fr-FR"} ;
            }
            if(resellerLocal && resellerLocal.r_nosync){
                //no sync, remove offline changes
                localStorage.setItem(api.currentUser.login+"_velox_offline_changes", "[]") ;
            }
            VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_ALWAYS) ;
            api.api.multiread({
                reseller_settings: {searchFirst : {r_code : api.currentUser.realms[0].realm.code}},
                reseller: {searchFirst : {r_code : api.currentUser.realms[0].realm.code}},
            }, function(err, reads){
                var reseller;
                if(err){
                    reseller = {r_lang: "fr-FR"} ;
                }
                reseller = reads.reseller;
                if(!reseller){ return ; }
                VeloxWebView.i18n.setLang(reseller.r_lang) ;
                var phoneCountry = reseller.r_lang.substring(0,2).toUpperCase();
                if(phoneCountry === "EN"){
                    phoneCountry = "GB" ;
                }
                VeloxWebView.fields.setPhoneCountry(phoneCountry) ;
                VeloxWebView.country.setOptions({country: reseller.r_lang.substring(0,2).toUpperCase()}) ;
                if(reseller.r_nosync){
                    //no sync, put the sync strategy to read only
                    VeloxDatabaseClient.setSyncStrategy(sync.SYNC_STRATEGY_READONLY) ;
                    if(VeloxServiceClient.setSyncBinaryAuto){
                        VeloxServiceClient.setSyncBinaryAuto(false) ;
                    }
                    //force sync to be only on reseller
                    var realSync =api.api.sync ;
                    api.api.sync = function(){
                        realSync.call(api.api, ["reseller", "reseller_settings"], arguments[arguments.length-1]) ;
                    } ;
                    if(window.native && window.native.backupOffline){
                        api.api.backup(function(err, dbString){
                            if(err){ return callback(err) ;}
                            window.native.backupOffline.backupData({dbString: dbString}, function(err, filename){
                                if(err){ return console.log("error when auto backup", err) ;}
                                console.log("auto backup done "+filename) ;
                                
                                // window.native.backupOffline.readAllDiags({}, function(err, allDiags){
                                //     if(err){ return console.log("error when auto restore diags", err) ;}
                                //     var calls = [] ;
                                //     var deletedDiags = [] ;
                                //     allDiags.forEach(function(d, i){
                                //         calls.push(function(cb){
                                //             api.api.diag.searchFirst({d_id: d.d_id}, function(err, foundDiag){
                                //                 if(err){ return cb(err) ;}
                                //                 if(!foundDiag){
                                //                     deletedDiags.push({
                                //                         table: "diag",
                                //                         record: d
                                //                     }) ;
                                //                 }
                                //                 if(i%100 === 0){
                                //                     setTimeout(function(){ cb() ;}, 1) ;
                                //                 }else{
                                //                     cb() ;
                                //                 }
                                //             }) ;
                                //         }) ;
                                //     }) ;
                                //     VeloxWebView._asyncSeries(calls, function(err){
                                //         if(err){ return console.log("error when auto restore diags", err) ;}
                                //         if(deletedDiags.length>0){
                                //             var msg = "Re insert diags : "+JSON.stringify(deletedDiags) ;
                                //             console.log(msg) ;
                                //             api.api.transactionalChanges(deletedDiags, function(err){
                                //                 if(err){ return console.log("error when auto restore diags", err) ;}
                                //                 var report = {
                                //                     app_name : "bayrol-solution-cloud-repair",
                                //                     app_version: "0.0.0",
                                //                     date : new Date(),
                                //                     user_agent: window.navigator.userAgent,
                                //                     url: window.location.href,
                                //                     error: msg
                                //                 } ;
                                //                 api.saveCrashReport(report, function(err){
                                //                     if(err){
                                //                         console.log("error while sending crash report") ;
                                //                     }
                                //                 }) ;
                                //             }) ;
                                //         }
                                //     }) ;
                                // }) ;
                            }) ;
                        }) ;
                    }
                }else{
                    //normal sync
                    VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_ALWAYS) ;
                }
                if(resellerLocal && resellerLocal.r_nosync && !reseller.r_nosync){
                    //change from nosync to sync
                    sync.resyncAll(api, function(){
                        migrateData(api, reseller, callback) ;
                    }) ;
                }else{
                    if(!reseller.r_nosync){
                        doFullSync(api) ;
                    }
                    migrateData(api, reseller, callback) ;
                }
            }.bind(this)) ;
        }.bind(this)) ;
    }else if(api.currentUser.lang){
        VeloxWebView.i18n.setLang(api.currentUser.lang) ;
        callback() ;
    }else{
        callback() ;
    }
} ;

function migrateData(api, reseller,  callback){
    if(!window.native || !window.native.migration){
        return callback() ;
    }
    api.api.velox_map.searchFirst({ code: "import_done", key: "done"}, function(err, mapDone){
        if(err){ return callback(err) ;}
        if(mapDone){
            //already done
            return callback() ;
        }

        var importDoneRecord = {
            table: "velox_map",
            record: {
                code: "import_done",
                key: "done",
                value: { date: new Date().toISOString() }
            }
        };

        window.native.migration.migrateData(function(err, data){
            if(err){ 
                VeloxWebView.error(VeloxWebView.tr("login.cantMigrateOldData")) ;
                api.api.transactionalChanges([importDoneRecord], callback) ;
                return ;
            }

            if(data === "NO_DATA"){
                return callback() ;
            }

            var records = [] ;
            var attachments = [] ;
            data.customers.forEach(function(customer){
                var customerId = reseller.r_code+"_"+new Date().getTime()+"_"+customer._id ;
                var address = customer.address||"" ;
                var addressLines = address.split("\n") ;
                var address1 = addressLines[0]||"" ;
                var address2 = "" ;
                if(addressLines.length > 1){
                    address2 = addressLines.slice(1).join(" ") ;
                }

                records.push({
                    table: "customer",
                    record: {
                        c_id             : customerId ,
                        r_code           : reseller.r_code ,
                        c_name           : customer.name ,
                        c_first_name     : customer.firstName ,
                        c_address1       : address1 ,
                        c_address2       : address2 ,
                        c_zipcode        : customer.zipCode ,
                        c_city           : customer.city ,
                        c_country        : customer.country ,
                        c_phone_home     : customer.phoneHome ,
                        c_phone_mobile   : customer.phoneMobile ,
                        c_phone_fax      : customer.phoneFax ,
                        c_email          : customer.email ,
                        c_ref_customer   : customer.refCustomer ,
                        c_notes          : customer.notesCustomer ,
                        c_optin_dealer   : false ,
                        c_optin_bayrol   : false
                    }
                }) ;

                if(customer.volume && customer.volume.volume){
                    var disingShock = null;
                    var disingLong = null;
                    if(customer.disinfectant && customer.disinfectant.disinf === "BROMINE"){
                        disingShock = customer.disinfectant.shockBr;
                        disingLong = customer.disinfectant.longBr;
                    }else if(customer.disinfectant && customer.disinfectant.disinf === "OXYGEN"){
                        disingShock = customer.disinfectant.shockOxy;
                        disingLong = customer.disinfectant.longOxy;
                    }else if(customer.disinfectant){
                        disingShock = customer.disinfectant.shockCl;
                        disingLong = customer.disinfectant.longCl;
                    }
                    records.push({
                        table: "pool",
                        record: {
                            p_id                      : uuid.v4(),
                            c_id                      : customerId,
                            p_volume                  : Math.round(customer.volume.volume),
                            p_shape                   : customer.volume.shape,
                            p_width                   : customer.volume.width,
                            p_length                  : customer.volume.length,
                            p_diameter                : customer.volume.diameter,
                            p_depth                   : customer.volume.depth,
                            p_pool_type               : customer.poolType,
                            p_pool_cover              : customer.poolCover?customer.poolCover.poolCover:null,
                            p_pool_cover_other        : customer.poolCover?customer.poolCover.other:null,
                            p_filter                  : customer.filter,
                            p_extra_installation      : customer.extraInstallation,
                            p_regulation              : customer.regulation?customer.regulation.regulation:null,
                            p_regulation_other        : customer.regulation?customer.regulation.other:null,
                            p_electrolyzer            : customer.electrolyzer?customer.electrolyzer.electrolyzer:null,
                            p_electrolyzer_other      : customer.electrolyzer?customer.electrolyzer.other:null,
                            p_extra_pump              : customer.extraPump,
                            p_extra_heater            : customer.extraHeater,
                            p_extra_engine            : customer.extraEngine,
                            p_extra_protection        : customer.extraProtection,
                            p_extra_cl_dosage         : customer.extraClDosage?customer.extraClDosage.extraClDosage:null,
                            p_extra_cl_dosage_other   : customer.extraClDosage?customer.extraClDosage.other:null,
                            p_extra_br_dosage         : customer.extraBrDosage?customer.extraBrDosage.extraBrDosage:null,
                            p_extra_br_dosage_other   : customer.extraBrDosage?customer.extraBrDosage.other:null,
                            p_extra_floc_dosage       : customer.extraFlocDosage?customer.extraFlocDosage.extraFlocDosage:null,
                            p_extra_floc_dosage_other : customer.extraFlocDosage?customer.extraFlocDosage.other:null,
                            p_extra_other             : customer.extraOther,
                            p_ph_correction           : customer.phCorrector,
                            p_alkalinity              : customer.alkalinity,
                            p_hardness                : customer.hardness,
                            p_disinfectant            : customer.disinfectant?customer.disinfectant.disinf:null,
                            p_disinf_shock            : disingShock,
                            p_disinf_long             : disingLong,
                            p_disinf_salt_rate        : customer.disinfectant?customer.disinfectant.saltRatePreco:null,
                            p_algae                   : customer.algae,
                            p_flocculation            : customer.flocculation,
                            p_cleaning                : customer.cleaning,
                            p_filter_maintenance      : customer.filterMaintenance,
                            p_wintering               : customer.wintering,
                            p_advanced_other          : customer.advancedOther
                        }
                    }) ;
                }

                if(customer.volumeSpa && customer.volumeSpa.volume){
                    var disingShock = null;
                    var disingLong = null;
                    if(customer.disinfectantSpa && customer.disinfectantSpa.disinfSpa === "BROMINE"){
                        disingShock = customer.disinfectantSpa.shockBrSpa;
                        disingLong = customer.disinfectantSpa.longBrSpa;
                    }else if(customer.disinfectantSpa && customer.disinfectantSpa.disinfSpa === "OXYGEN"){
                        disingShock = customer.disinfectantSpa.shockOxySpa;
                        disingLong = customer.disinfectantSpa.longOxySpa;
                    }else if(customer.disinfectantSpa){
                        disingShock = customer.disinfectantSpa.shockClSpa;
                        disingLong = customer.disinfectantSpa.longClSpa;
                    }
                    records.push({
                        table: "spa",
                        record: {
                            s_id                      : uuid.v4(),
                            c_id                     : customerId,
                            s_volume                 : customer.volumeSpa.volume,
                            s_shape                  : customer.volumeSpa.shape,
                            s_width                  : customer.volumeSpa.width,
                            s_length                 : customer.volumeSpa.length,
                            s_depth                  : customer.volumeSpa.depth,
                            s_diameter               : customer.volumeSpa.diameter,
                            s_spa_type               : customer.spaType,
                            s_spa_cover              : customer.spaCover?customer.spaCover.spaCover:null,
                            s_spa_cover_other        : customer.spaCover?customer.spaCover.other:null,
                            s_filter                 : customer.filterSpa,
                            s_extra_installation     : customer.extraInstallationSpa,
                            s_regulation             : customer.regulationSpa?customer.regulationSpa.regulationSpa:null,
                            s_regulation_other       : customer.regulationSpa?customer.regulationSpa.other:null,
                            s_extra_pump             : customer.extraPumpSpa,
                            s_extra_heater           : customer.extraHeaterSpa,
                            s_extra_engine           : customer.extraEngineSpa,
                            s_extra_protection       : customer.extraProtectionSpa?customer.extraProtectionSpa.extraProtectionSpa:null,
                            s_extra_protection_other : customer.extraProtectionSpa?customer.extraProtectionSpa.other:null,
                            s_extra_cl_dosage        : customer.extraClDosageSpa?customer.extraClDosageSpa.extraClDosageSpa:null,
                            s_extra_cl_dosage_other  : customer.extraClDosageSpa?customer.extraClDosageSpa.other:null,
                            s_extra_br_dosage        : customer.extraBrDosageSpa?customer.extraBrDosageSpa.extraBrDosageSpa:null,
                            s_extra_br_dosage_other  : customer.extraBrDosageSpa?customer.extraBrDosageSpa.other:null,
                            s_extra_other            : customer.extraOtherSpa,
                            s_water_balance          : customer.waterBalanceSpa,
                            s_disinfectant           : customer.disinfectantSpa?customer.disinfectantSpa.disinfSpa:null,
                            s_disinf_shock           : disingShock,
                            s_disinf_long            : disingLong,
                            s_disinf_salt_rate       : null,
                            s_other_product          : customer.otherProductsSpa
                        }
                    });
                }

                if(customer.diags){
                    customer.diags.forEach(function(diag){
                        var disingShock = null;
                        var disingLong = null;
                        if(diag.disinfectant && diag.disinfectant.disinf === "BROMINE"){
                            disingShock = diag.disinfectant.shockBr;
                            disingLong = diag.disinfectant.longBr;
                        }else if(diag.disinfectant && diag.disinfectant.disinf === "OXYGEN"){
                            disingShock = diag.disinfectant.shockOxy;
                            disingLong = diag.disinfectant.longOxy;
                        }else if(diag.disinfectant){
                            disingShock = diag.disinfectant.shockCl;
                            disingLong = diag.disinfectant.longCl;
                        }

                        var disingShockSpa = null;
                        var disingLongSpa = null;
                        if(diag.disinfectantSpa && diag.disinfectantSpa.disinfSpa === "BROMINE"){
                            disingShockSpa = diag.disinfectantSpa.shockBrSpa;
                            disingLongSpa = diag.disinfectantSpa.longBrSpa;
                        }else if(diag.disinfectantSpa && diag.disinfectantSpa.disinfSpa === "OXYGEN"){
                            disingShockSpa = diag.disinfectantSpa.shockOxySpa;
                            disingLongSpa = diag.disinfectantSpa.longOxySpa;
                        }else if(diag.disinfectantSpa){
                            disingShockSpa = diag.disinfectantSpa.shockClSpa;
                            disingLongSpa = diag.disinfectantSpa.longClSpa;
                        }

                        var diagId = uuid.v4() ;
                        records.push({
                            table: "diag",
                            record: {
                                d_id                     : diagId,
                                c_id                     : customerId,
                                d_pool_or_spa            : (diag.poolOrSpa||"POOL").toUpperCase(),
                                p_volume                 : diag.volume?Math.round(diag.volume.volume):null,
                                p_filter                 : diag.filter,
                                p_extra_installation     : diag.extraInstallation,
                                p_pool_cover             : diag.poolCover?diag.poolCover.poolCover:null,
                                p_pool_cover_other       : diag.poolCover?diag.poolCover.other:null,
                                p_regulation             : diag.regulation?diag.regulation.regulation:null,
                                p_regulation_other       : diag.regulation?diag.regulation.other:null,
                                p_electrolyzer           : diag.electrolyzer?diag.electrolyzer.electrolyzer:null,
                                p_electrolyzer_other     : diag.electrolyzer?diag.electrolyzer.other:null,
                                p_ph_correction          : diag.phCorrector,
                                p_alkalinity             : diag.alkalinity,
                                p_hardness               : diag.hardness,
                                p_disinfectant           : diag.disinfectant?diag.disinfectant.disinf:null,
                                p_disinf_shock           : disingShock,
                                p_disinf_long            : disingLong,
                                p_disinf_salt_rate       : diag.disinfectant?diag.disinfectant.saltRatePreco:null,
                                p_algae                  : diag.algae,
                                p_flocculation           : diag.flocculation,
                                p_cleaning               : diag.cleaning,
                                p_filter_maintenance     : diag.filterMaintenance,
                                p_wintering              : diag.wintering,
                                p_advanced_other         : diag.advancedOther,
                                s_volume                 : diag.volumeSpa?diag.volumeSpa.volume:null,
                                s_spa_cover              : diag.spaCover?diag.spaCover.spaCover:null,
                                s_spa_cover_other        : diag.spaCover?diag.spaCover.other:null,
                                s_filter                 : diag.filterSpa,
                                s_extra_installation     : diag.extraInstallationSpa,
                                s_regulation             : diag.regulationSpa?diag.regulationSpa.regulationSpa:null,
                                s_regulation_other       : diag.regulationSpa?diag.regulationSpa.other:null,
                                s_water_balance          : diag.waterBalanceSpa,
                                s_disinfectant           : diag.disinfectantSpa?diag.disinfectantSpa.disinfSpa:null,
                                s_disinf_shock           : disingShockSpa,
                                s_disinf_long            : disingLongSpa,
                                s_disinf_salt_rate       : null,
                                s_other_product          : diag.otherProductsSpa,
                                d_date                   : diag.date,
                                d_notes                  : diag.notes,
                                d_join_notes             : !!diag.notes,
                                d_diag_price             : diag.diagPrice,
                                d_diag_user              : diag.diagUser,
                                d_alk                    : diag.alk,
                                d_ph                     : diag.pH,
                                d_hardness               : diag.hardnessMes,
                                d_free_cl                : diag.freeCl,
                                d_total_cl               : diag.totalCl,
                                d_br                     : diag.br,
                                d_salt                   : diag.saltRate,
                                d_salt_disolved          : null,
                                d_oxygen                 : diag.oxygenRate,
                                d_cu                     : diag.cu,
                                d_fe                     : diag.fe,
                                d_stab                   : diag.stab,
                                d_temperature            : diag.temperature,
                                d_phosphate              : diag.phosphate,
                                d_salt_disolved_sign     : null,
                                d_ph_sign                : diag.signs?diag.signs.pH:null,
                                d_hardness_sign          : diag.signs?diag.signs.hardness:null,
                                d_free_cl_sign           : diag.signs?diag.signs.freeCl:null,
                                d_total_cl_sign          : diag.signs?diag.signs.totalCl:null,
                                d_br_sign                : diag.signs?diag.signs.br:null,
                                d_salt_sign              : diag.signs?diag.signs.salt:null,
                                d_oxygen_sign            : diag.signs?diag.signs.oxygen:null,
                                d_cu_sign                : diag.signs?diag.signs.cu:null,
                                d_fe_sign                : diag.signs?diag.signs.fe:null,
                                d_stab_sign              : diag.signs?diag.signs.stab:null,
                                d_phosphate_sign         : diag.signs?diag.signs.phosphate:null,
                                d_mode                   : diag.optionsMode,
                                d_filter_maint           : diag.optionsFilterMaint,
                                d_clean_line             : diag.optionsCleanLine,
                                d_startup                : diag.optionsStartUp,
                                d_wintering              : diag.optionsWintering,
                                d_marks                  : diag.optionsMark,
                                d_green_algae            : diag.optionsGreenWaterAlgae,
                                d_green_water_crystal    : diag.optionsGreenWaterCrystal,
                                d_trouble_water          : diag.optionsTroubleWater,
                                d_mousse                 : diag.optionsMousse,
                                d_marks_spa              : diag.optionsMarkSpa,
                                d_sta_council            : diag.staCouncil,
                                d_temp_council           : diag.temp2Council,
                            }
                        });

                        if(diag.customProducts){
                            diag.customProducts.forEach(function(p){
                                records.push({
                                    table: "diag_custom_product",
                                    record: {
                                        dcp_id           : uuid.v4(),
                                        d_id             : diagId,
                                        dcp_product_name : p 
                                    }
                                });
                            }) ;
                        }
                    }) ;
                }

                if(customer.attachments){
                    customer.attachments.forEach(function(attach){
                        var docUid = uuid.v4() ;
                        records.push({
                            table: "doc",
                            record: {
                                doc_id: docUid,
                                c_id: customerId,
                                doc_filename: attach.filename
                            }
                        }) ;
                        attachments.push({
                            docUid: docUid,
                            customer: customer,
                            c_id: customerId,
                            filename: attach.filename,
                            attach: attach
                        }) ;
                    }) ;
                }


            }) ;

            if(data.settings.options){
                records.push({
                    table: "reseller_settings",
                    record: {
                        r_code          : reseller.r_code,
                        rs_shop_name    : data.settings.options.shopName,
                        rs_email        : data.settings.options.email,
                        rs_diag_price   : data.settings.options.diagPrice,
                        rs_print_color  : data.settings.options.printColor,
                        rs_textbox      : data.settings.text
                    }
                }) ;
            }

            if(data.searches){
                data.searches.forEach(function(search){
                    if(!search.search){ return ;}
                    if(!search.search.forEach){ return ;}
                    var searchMap = {} ;
                    search.search.forEach(function(s){
                        var ope = s.operator ;
                        if(ope === "begins"){
                            ope = "startWith" ;
                        }else if(ope === "is"){
                            ope = "equal" ;
                        }else if(ope === "ends"){
                            ope = "contains" ;
                        }
                        var field = s.field ;
                        if(field === "name") { field = "c_name" ;}
                        else if(field === "firstName") { field = "c_first_name"; }
                        else if(field === "zipCode") { field = "c_zipcode"; }
                        else if(field === "city") { field = "c_city"; }
                        else if(field === "country") { field = "c_country"; }
                        else if(field === "phoneHome") { field = "c_phone_home"; }
                        else if(field === "phoneMobile") { field = "c_phone_mobile"; }
                        else if(field === "phoneFax") { field = "c_phone_fax"; }
                        else if(field === "email") { field = "c_email"; }
                        else if(field === "refCustomer") { field = "c_ref_customer"; }
                        else if(field === 'notesCustomer'       ) { field = "c_notes"; }
                        else if(field === 'volume'              ) { field = "p_volume"; }
                        else if(field === 'poolType'            ) { field = "p_pool_type"; }
                        else if(field === 'poolCover'           ) { field = "p_pool_cover"; }
                        else if(field === 'filter'              ) { field = "p_filter"; }
                        else if(field === 'extraInstallation'   ) { field = "p_extra_installation"; }
                        else if(field === 'regulation'          ) { field = "p_regulation"; }
                        else if(field === 'electrolyzer'        ) { field = "p_electrolyzer"; }
                        else if(field === 'extraPump'           ) { field = "p_extra_pump"; }
                        else if(field === 'extraHeater'         ) { field = "p_extra_heater"; }
                        else if(field === 'extraEngine'         ) { field = "p_extra_engine"; }
                        else if(field === 'extraProtection'     ) { field = "p_extra_protection"; }
                        else if(field === 'extraClDosage'       ) { field = "p_extra_cl_dosage"; }
                        else if(field === 'extraBrDosage'       ) { field = "p_extra_br_dosage"; }
                        else if(field === 'extraFlocDosage'     ) { field = "p_extra_floc_dosage"; }
                        else if(field === 'extraOther'          ) { field = "p_extra_other"; }
                        else if(field === 'phCorrector'         ) { field = "p_ph_correction"; }
                        else if(field === 'alkalinity'          ) { field = "p_alkalinity"; }
                        else if(field === 'hardness'            ) { field = "p_hardness"; }
                        else if(field === 'disinfectant'        ) { field = "p_disinfectant"; }
                        else if(field === 'disinfectantShock'   ) { field = "p_disinf_shock"; }
                        else if(field === 'disinfectantLong'    ) { field = "p_disinf_long"; }
                        else if(field === 'saltRateReco'        ) { field = "p_disinf_salt_rate"; }
                        else if(field === 'algae'               ) { field = "p_algae"; }
                        else if(field === 'flocculation'        ) { field = "p_flocculation"; }
                        else if(field === 'cleaning'            ) { field = "p_cleaning"; }
                        else if(field === 'filterMaintenance'   ) { field = "p_filter_maintenance"; }
                        else if(field === 'wintering'           ) { field = "p_wintering"; }
                        else if(field === 'advancedOther'       ) { field = "p_advanced_other"; }
                        else if(field === 'disinfectantSpa'     ) { field = "s_disinfectant"; }
                        else if(field === 'disinfectantShockSpa') { field = "s_disinf_shock"; }
                        else if(field === 'disinfectantLongSpa' ) { field = "s_disinf_long"; }
                        else if(field === 'volumeSpa'           ) { field = "s_volume"; }
                        else if(field === 'spaType'             ) { field = "s_spa_type"; }
                        else if(field === 'spaCover'            ) { field = "s_spa_cover"; }
                        else if(field === 'filterSpa'           ) { field = "s_filter"; }
                        else if(field === 'extraInstallationSpa') { field = "s_extra_installation"; }
                        else if(field === 'regulationSpa'       ) { field = "s_regulation"; }
                        else if(field === 'extraPumpSpa'        ) { field = "s_extra_pump"; }
                        else if(field === 'extraHeaterSpa'      ) { field = "s_extra_heater"; }
                        else if(field === 'extraEngineSpa'      ) { field = "s_extra_engine"; }
                        else if(field === 'extraProtectionSpa'  ) { field = "s_extra_protection"; }
                        else if(field === 'extraClDosageSpa'    ) { field = "s_extra_cl_dosage"; }
                        else if(field === 'extraBrDosageSpa'    ) { field = "s_extra_br_dosage"; }
                        else if(field === 'extraOtherSpa'       ) { field = "s_extra_other"; }
                        else if(field === 'waterBalanceSpa'     ) { field = "s_water_balance"; }
                        else if(field === 'otherProductsSpa'    ) { field = "s_other_product"; }
                        searchMap[s.field] = {
                            ope: ope,
                            value: s.value
                        } ;
                    }) ;
                    records.push({
                        table: "velox_map",
                        record: {
                            code: "velox_grid_search_saved",
                            key: search.name.substring(0,128),
                            value: searchMap
                        }
                    }) ;
                }) ;
            }

            records.push(importDoneRecord) ;

            api.api.transactionalChanges(records, function(err){
                if(err){ return callback(err) ;}
                var calls = [function(cb){cb() ;}] ;

                if(data.settings.logoBase64){
                    calls.push(function(cb){
                        var binary_string =  window.atob(data.settings.logoBase64);
                        var len = binary_string.length;
                        var bytes = new Uint8Array( len );
                        for (var i = 0; i < len; i++)        {
                            bytes[i] = binary_string.charCodeAt(i);
                        }
                        api.api.velox_binary.searchFirst({table_uid: reseller.r_code, table_name: "reseller_settings"}, function(err, binary){
                            if(err){ return cb(err) ;}
                            var binaryRecord = {
                                table_name: "reseller_settings", 
                                table_uid: reseller.r_code, 
                                //mime_type: file.type,
                                description : "logo",
                                filename: "logo"
                            } ;
                            if(binary){
                                binaryRecord.uid = binary.uid ;
                            }
                            api.saveBinary(
                                bytes.buffer,binaryRecord , cb) ;
                        }) ;
                    });
                }

                attachments.forEach(function(attach){
                    calls.push(function(cb){
                        var binary_string =  window.atob(attach.attach.bufferBase64);
                        var len = binary_string.length;
                        var bytes = new Uint8Array( len );
                        for (var i = 0; i < len; i++)        {
                            bytes[i] = binary_string.charCodeAt(i);
                        }
                        api.saveBinary(
                            bytes.buffer,
                            {
                            table_name: "doc", 
                            table_uid: attach.docUid, 
                            description : attach.filename,
                            filename: attach.filename
                        }, cb) ;
                    }) ;
                }) ;

                VeloxWebView._asyncSeries(calls, callback) ;
            }) ;
        }) ;
    });
}


var fullSyncDone = false;

function doFullSync(api){
    if(!fullSyncDone && api.currentUser && api.currentUser.login !== "anonymous"){ 
        VeloxServiceClient.setOfflineTableBinarySettings({
            velox_mail: {
                cached: true,
                prefetch: false,
            },
            extrabat_diag: {
                cached: true,
                prefetch: false,
            }
        })
        fullSyncDone = true ;
        if(window.native){
            console.log("binary sync") ;
            api.syncBinary(function(err){
                if(err){
                    console.log("binary sync failed", err) ;
                    fullSyncDone = false;
                }
            }) ;
        }
        console.log("database sync") ;
        api.api.sync(function(err){
            if(err){
                console.log("database sync failed", err) ;
                fullSyncDone = false;
            }
        }) ;
    } 
}